import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const requiredRoles = route.data['roles'] as string[];

    const user = authService.getCurrentUserValue();

    if (!user || !user.roles) {
        // Not logged in or no roles, redirect to login
        router.navigate(['/auth/login'], {
            queryParams: { returnUrl: state.url },
        });
        return false;
    }

    const hasRole = requiredRoles.some(role => user.roles?.includes(role));

    if (hasRole) {
        return true;
    }

    // User does not have the required role
    // Redirect to default route according to category and roles
    const defaultRoute = authService.getDefaultRoute();
    router.navigate([defaultRoute]);
    return false;
};
